import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row } from 'react-bootstrap';
import coverImage from 'assets/img/generic/cover-campaign.png';
import { CoverUploadSquare } from 'components/common/CoverUpload';
import AvatarUpload from 'components/common/AvatarUpload';
import CampaignTodayCalling from 'pages/hvamanagement/CampaignTodayCalling';
import CampaignTodayCalls from 'pages/hvamanagement/CampaignTodayCalls';
import { faPersonDigging } from '@fortawesome/free-solid-svg-icons';
import CampaignKPICard2 from 'components/cards/CampaignKPICard2';

interface CampaignTodayProps {
  campaignId: number;
  campaignbxpId: number;
  campaignType: 'outbound' | 'inbound';
  title: string;
  brand: string;
}

const CampaignToday: React.FC<CampaignTodayProps> = ({
  campaignId,
  campaignbxpId,
  campaignType = 'outbound',
  title,
  brand
}) => {
  const { setContentClass } = useMainLayoutContext();
  const [avatarSrc, setAvatarSrc] = useState<string>(
    brand ? `/brands/${brand.toLowerCase()}.png` : '/brands/default.png'
  );

  const handleAvatarError = () => {
    setAvatarSrc('/brands/default.png');
  };
  useEffect(() => {
    setContentClass('px-0 pt-navbar');

    return () => {
      setContentClass('');
    };
  }, []);

  return (
    <Card className="mb-0 border-0">
      <Card.Header
        className="d-flex justify-content-center position-relative mb-0 mb-xl-0 p-0"
        style={{ height: '80px' }}
      >
        <CoverUploadSquare src={coverImage} />
        <AvatarUpload
          size="3xl"
          src={avatarSrc}
          thumbnail={true}
          className="feed-profile"
          imageClassName="border-0"
          onError={handleAvatarError}
        />
      </Card.Header>
      <Card.Body>
        <Row className="px-6">
          <nav aria-label="breadcrumb" className="p-0 pb-1">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={`/`}>Actual calling</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page"></li>
            </ol>
          </nav>

          <div className="mb-3 p-0">
            <h3 className="me-2">{title}</h3>
          </div>
        </Row>
        <Row className="px-6">
          <div className="mb-1 p-0 pt-2">
            <h5 className="text-body-tertiary">
              Workload and Calling statistics
            </h5>
          </div>
          <Card className="mb-3 bg-body">
            <Card.Body>
              <CampaignKPICard2
                icon={faPersonDigging}
                color="primary-dark"
                label="Last 30 days"
                title="Workload evolution "
                title2="(# of customer)"
                campaignid={campaignbxpId}
              />
              <CampaignTodayCalling
                campaignid={campaignbxpId}
                campaignType={campaignType}
              />
            </Card.Body>
          </Card>
        </Row>
        <Row className="px-6">
          <div className="mb-1 p-0">
            <h5 className="text-body-tertiary">Actual calls</h5>
          </div>
          <Card className="mb-3 bg-body">
            <Card.Body>
              <CampaignTodayCalls campaignid={campaignId} />
            </Card.Body>
          </Card>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CampaignToday;
